import React, { useEffect, useMemo, useState, useRef } from "react";
import { makeStyles } from '@mui/styles';
import { createTheme } from '@mui/material/styles';
import DataGrid,{ SelectColumn, useRowSelection } from 'react-data-grid';
import 'react-data-grid/lib/styles.css';
import { CellExpanderFormatter } from './cellexpanderformatter';
import moment from "moment";
import { Badge, Box, Typography, IconButton, Tooltip, Checkbox, ListItem, Card, CardContent } from "@mui/material";
import { EditOutlined } from '@mui/icons-material';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import UnpublishedIcon from '@mui/icons-material/Unpublished';
import Helper from "../../utility/helper";

const GRID_ROW_HEIGHT = 90;
const GRID_HEADER_ROW_HEIGHT = 40;

const theme = createTheme();
const useStyles = makeStyles(() => ({
    cellExpandClassname: {
        float: 'right',
        float: 'inline-end',
        display: 'table',
        blockSize: '100%',
        "& span": {
            display: 'table-cell',
            verticalAlign: 'middle',
            cursor: 'pointer'
        }
    },
    enablesTextWrapping: {
        display: 'inline-block',
        lineHeight: 1.5,
        overflowWrap: 'break-word',
        whiteSpace: 'normal',
        textAlign: 'justify'
    },
    addPad: {
        padding: theme.spacing(2),
    },
    addHeader: {
        backgroundColor: "#17408B",
        color: 'white'
    },
    noHeaderWrapper: {
        '& .rdg-header-row': {
            display: 'none'
        }
    },
    accordionHeader: {
        textTransform: 'uppercase',
        fontWeight: 600,
        color: 'white',
        padding: '10px 0',
        cursor: 'pointer',
    },
    listItemContent: {
        padding: theme.spacing(1, 0),
    },
    paperContent: {
        boxShadow:
            '0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)', // made the changes for consistent styling
        borderRadius: theme.spacing(2),
        padding: theme.spacing(1),
        backgroundColor: '#fff',
        border: '1px solid #efefef',
    },
    cardContent: {
        padding: 0,
        '&:last-child': {
            paddingBottom: 0,
        },
    },
    rowContent: {
        flex: 1,
        display: 'flex',
        justifyContent: 'center',
    },
    activityContainer: {
        '& .rdg-header-row': {
            '& .rdg-cell': {
                zIndex: 10
            },
        },
        '& .rdg-cell': {
            zIndex: 1
        },
    },
    container: {
        // '& ::-webkit-scrollbar': {
        //     width: '6px!important',
        //     height: '6px!important',
        //     backgroundColor: '#f1f1f1',
        // },
        // '& ::-webkit-scrollbar-thumb:horizontal': {
        //     background: '#c1c1c1!important',
        // },
    }
}));
const userInfo = Helper.getStorage('userInfo');
const endUser = false;

const CustomScheduleGrid = (props) => {
    const classes = useStyles();
    const [rows, setRows] = useState([]);
    const [activityData, setActivityData] = useState([]);
    const [dateObj, setDateObj] = useState([]);
    const [scrollPositionObj, setScrollPositionObj] = useState([]);
    // const [actionButton, setActionButton] = useState(false);
    // const [rowExpanded, setRowExpanded] = useState(false);
    useEffect(() => {
        if (props.dates && props.dates.length > 0 && (!dateObj || dateObj.length === 0)) {
            let dateArr = [];
            setDateObj(props.dates);
            props.dates.forEach((date, index) => {
                dateArr.push({
                    type: 'Date',
                    id: 'date_' + index,
                    index: index,
                    date: date,
                    expanded: false
                })
            })
            // console.log('dateArr : ', dateArr);
            setRows(dateArr);
            //setScrollPositionObj([]);
        }

    }, [props.dates])

    useEffect(() => {
        if (props.dates && props.dates.length > 0 && dateObj && dateObj.length > 0) {
            setDateObj(props.dates);

            if (props.selectedUserName) {
                let dateArr = [];
                let updatedRows = [...props.dates];
                updatedRows.forEach((date, index) => {
                    // console.log('onRowsChange : ', row);
                    // setRowExpanded(true);
                    let parentRow = {
                        type: 'Date',
                        id: 'date_' + index,
                        index: index,
                        date: date,
                        expanded: true
                    }
                    dateArr.push(parentRow);

                    if (props.selectedUserName) {
                        // updatedRows.splice(index + 1, 0,);

                        let data = props.data ? props.data.filter(x =>
                            moment(x.actualData.startDateTime).format('MM/DD/YYY')
                            == moment(date).format('MM/DD/YYY')) : [];
                        let rowHeight = data.length <= 3 ? GRID_ROW_HEIGHT * data.length + GRID_HEADER_ROW_HEIGHT + 30 : 350;
                        dateArr.push({
                            type: 'DETAIL',
                            id: parentRow.id + "_" + 100,
                            parentId: parentRow.id,
                            rowHeight: rowHeight
                        });
                    }

                });
                setRows(dateArr);
            }
            else if (JSON.stringify(props.dates) !== JSON.stringify(dateObj)) {
                let dateArr = [];
                props.dates.forEach((date, index) => {
                    dateArr.push({
                        type: 'Date',
                        id: 'date_' + index,
                        index: index,
                        date: date,
                        expanded: false
                    })
                })
                setRows(dateArr);
            }
            //setScrollPositionObj([]);
        }
    }, [props.dates, dateObj, props.selectedUserName])

    useEffect(() => {

        if (props.data && props.data.length > 0) {
            setActivityData(props.data);
        }
        // else if (props.data.length > 0 && activityData.length > 0) {
        //     let actdata = []; let stateactdata = [];
        //     props.data.map(row => actdata.push(row.actualData));
        //     activityData.map(row => stateactdata.push(row.actualData));
        //     // console.log('props actdata : ', actdata);
        //     // console.log('state actdata : ', activityData);
        //     // console.log("after props change : ", props.data);
        //     // console.log('props is not changed: ', compareTwoArrayOfObjects(actdata,stateactdata));
        //     if (!compareTwoArrayOfObjects(actdata, stateactdata)) {
        //         setActivityData(props.data);
        //     }
        // }
        else {
            setActivityData([]);
        }
    }, [props.data])

    let compareTwoArrayOfObjects = (
        first_array_of_objects,
        second_array_of_objects
    ) => {
        return (
            first_array_of_objects.length === second_array_of_objects.length &&
            first_array_of_objects.every((element_1) =>
                second_array_of_objects.some((element_2) =>
                    Object.keys(element_1).every((key) => element_1[key] === element_2[key])
                )
            )
        );
    };
    // useEffect(() => {
    //     console.log('in expanded props : ', props);
    // }, [rowExpanded]);

    // useEffect(() => {
    //     if (rows && rows.length > 0)
    //         console.log("dateDetail : ", rows);
    // }, [rows])


    const columns = useMemo(() => {
        return [
            {
                key: "expanded",
                name: "",
                width: '3%',
                // formatter: ({row}) => (
                //     <div className={classes.cellExpandClassname}>
                //         <span onClick={() => onRowChange({ ...row, expanded: !row.expanded })}>
                //         <span >{row.expanded ? "\u25BC" : "\u25B6"}</span>
                //         </span>
                //     </div>
                // ),
                colSpan(args) {
                    return args.type === 'ROW' && args.row.type === 'DETAIL' ? 2 : undefined;
                },
                cellClass(row) {
                    return row.type === 'DETAIL'
                        ? classes.addPad
                        : classes.addHeader;
                },
                renderCell({ row, tabIndex, onRowChange }) {
                    // console.log('render cell props: ', row, tabIndex, onRowChange);

                    // return (
                    //     <h2>here</h2>
                    // )
                    if (row.type === "DETAIL") {
                        const products = getDayActivities(row.parentId);
                        return <ActivityGrid products={products}
                            parentID={row.parentId}
                            direction={props.direction} />
                    }

                    return (
                        <CellExpanderFormatter
                            expanded={row.expanded}
                            tabIndex={tabIndex}
                            onCellExpand={() => {
                                onRowChange({ ...row, expanded: !row.expanded });
                            }}
                        />
                    )
                }
            },
            //   { key: 'id', name: 'ID', width: 35 },
            {
                key: "date", name: "", width: '97%',
                cellClass(row) {
                    return classes.addHeader;
                },
                renderCell({ row, tabIndex, onRowChange }) {
                    return (
                        // <span>{moment(row.date).format('dddd, MMMM D, YYYY')}</span>
                        <Typography
                            className={classes.accordionHeader} onClick={() => onRowChange({ ...row, expanded: !row.expanded })}>
                            {row.date !== 'TBD'
                                ? moment(row.date).format(
                                    'dddd, MMMM D, YYYY'
                                )
                                : row.date}
                        </Typography>
                    )
                }
            },
        ];
    }, [rows, activityData]);

    // const onRowChange = (row) => {
    //     debugger
    //     console.log('rows: ', row);
    //     console.log("before update rows : ", props.dates);
    //     let newdates = props.dates;
    //     // console.log('indexes: ', indexes);
    //     // if (rows.expanded)
    //     // const row = rows[indexes[0]]
    //     if (row.type === "Date") {
    //         if (row.expanded) {
    //             let index = newdates.findIndex(dat => dat.id == row.id);
    //             console.log(index)
    //             newdates[index].expanded = true;
    //         }
    //         //   else {
    //         //     dateDetail.splice(row.id + 1, 1)
    //         //   }
    //         setDateDetail(newdates);
    //     }
    // }
    function onRowsChange(rows, { indexes }) {
        const row = rows[indexes[0]]
        // console.log('onRowsChange : ', row);
        // setRowExpanded(true);
        if (row.type === 'Date') {
            if (row.expanded) {
                let data = props.data ? props.data.filter(x =>
                    moment(x.actualData.startDateTime).format('MM/DD/YYY')
                    == moment(row.date).format('MM/DD/YYY')) : [];
                let rowHeight = data.length <= 3 ? GRID_ROW_HEIGHT * data.length + GRID_HEADER_ROW_HEIGHT + 30 : 350;
                rows.splice(indexes[0] + 1, 0, {
                    type: 'DETAIL',
                    id: row.id + "_" + 100,
                    parentId: row.id,
                    rowHeight: rowHeight
                });

            } else {
                rows.splice(indexes[0] + 1, 1);
            }
            // console.log('rows : ', rows);
            setRows(rows);
        }
        // console.log('onRowsChange indexes : ', indexes);
    }

    function getDayActivities(index) {
        // console.log('day act index : ', index);
        // debugger
        let ind = rows.findIndex(dat => dat.id == index);
        let date = rows[ind];
        let list = [...activityData];
        let arrayPush = [];
        let actdata = list.filter((x) => {
            if (x.actualData.startDateTime !== null) {
                //&& x.actualData.endDateTime !== null
                if (
                    moment(date.date).format('MM/DD/YYY') ==
                    moment(
                        x.actualData.startDateTime
                    ).format('MM/DD/YYY')
                ) {
                    //&& moment(date).format('MM/DD/YYY') <= moment(x.actualData.endDateTime).format('MM/DD/YYY')
                    arrayPush.push(x.actualData);
                    return x;
                }
            } else if (
                date === 'TBD' &&
                x.actualData.startDateTime === null &&
                x.actualData.endDateTime === null
            ) {
                arrayPush.push(x.actualData);
                return x;
            }
        });
        // console.log(`actdata : ${index} :`, arrayPush);
        // console.log(`actdata old :  :`, actdata);
        // actdata.forEach((i, index) => {
        //     i.index = index;
        // })
        return actdata;
    }

    const onCheckSelect = (event, row) => {
        props.onCheckSelect(event, row);

        //console.log('row', row)
        //saveGridScrollPosition(row);
    }

    const saveGridScrollPosition = (row) => {
        let date = moment(row.actualData.startDateTime).format('MM/DD/YYY');
        let obj = [...scrollPositionObj];
        if (!obj.some(i => i.date === date)) {
            obj.push({ date: date, scrollPosition: row.index });
        }
        else {
            let index = obj.findIndex(i => i.date === date);
            obj[index].scrollPosition = row.index;
        }
        setScrollPositionObj(obj);
    }

    const activityColumns = //useMemo(() => {
        //return 
        [
            {
                key: 'activityID',
                name: '',
                width: '5%',
                renderCell({ row }) {
                    const item = row.actualData;
                    return (
                        !props.showUserActivity ?
                            <Checkbox
                                inputProps={{
                                    'aria-label': 'Participant',
                                }}
                                checked={row.selected ? row.selected : false}
                                onChange={(event) => onCheckSelect(event, row)}
                                //value={actData.activityID}
                                sx={{ marginLeft: theme.spacing(0.75) }}
                            />
                            : null
                    )
                }
            },
            {
                key: "startDateTime",
                name: "Start Time",
                width: props.showUserActivity ? '10%' : '7%',
                renderCell({ row }) {
                    const item = row.actualData;
                    return item.startDateTime !== null
                        ? moment(item.startDateTime).format(
                            'hh:mm A'
                        ) : ''
                }
            },
            {
                key: "endDateTime",
                name: "End Time",
                width: props.showUserActivity ? '10%' : '7%',
                renderCell({ row }) {
                    const item = row.actualData;
                    return item.endDateTime !== null
                        ? moment(item.endDateTime).format(
                            'hh:mm A'
                        ) : ''
                }
            },
            {
                key: "activityName",
                name: "Activity",
                width: '20%',
                cellClass(row) {
                    return classes.enablesTextWrapping
                },
                renderCell({ row }) {
                    const item = row.actualData;
                    return (
                        <Box sx={{ position: 'relative', top: '50%', transform: 'translateY(-50%)' }}>
                            <Typography
                                variant="h4"
                                flexGrow={1}
                                fontSize={14}
                                fontWeight={600}>{item.activityName}</Typography>
                            {item.notes ?
                                <Tooltip title={item.notes}>
                                    <div style={{ overflow: "hidden", textOverflow: "ellipsis", width: props.showUserActivity ? '12rem' : '15rem' }}>
                                        <Typography
                                            fontSize={11}
                                            noWrap
                                        // sx={{
                                        //     wordBreak: 'break-word',
                                        //     fontWeight: 'bold'
                                        // }}
                                        >
                                            Notes: {item.notes}
                                        </Typography>
                                    </div>
                                </Tooltip>
                                : null}
                        </Box>
                    )
                }
            },
            {
                key: "attire",
                name: "Attire",
                width: '10%',
                cellClass(row) {
                    return classes.enablesTextWrapping
                },
                renderCell({ row }) {
                    const item = row.actualData;
                    return (
                        <Box style={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                            {item.attire}
                        </Box>
                    )
                }
            },
            {
                key: "location",
                name: "Location",
                width: '14%',
                cellClass(row) {
                    return classes.enablesTextWrapping
                },
                renderCell({ row }) {
                    const item = row.actualData;
                    return (
                        <Box style={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                            <Tooltip title={item.location} aria-label={item.location}>{item.location}</Tooltip>
                        </Box>
                    )
                }
            },
            {
                key: "participants",
                name: "Participants",
                width: '23%',
                cellClass(row) {
                    return classes.enablesTextWrapping
                },
                renderCell({ row }) {
                    const item = row.actualData;
                    return item.participants.map((vals, index) => {
                        const splitD = vals.participant.replace(',', '').split(' ')
                        if (item.participants.length > 4) {
                            return (
                                <React.Fragment key={`pSubActivity_${index}`}>
                                    <Typography
                                        fontSize={11}
                                        key={vals.userID}
                                        component="span"
                                        title={vals.participant}
                                        sx={{
                                            marginRight: '2px',
                                            cursor: 'pointer',
                                            fontWeight: endUser ? userInfo.userID === vals.userID ? '900' : null : null,
                                        }}>
                                        {(splitD[2] !== undefined ? splitD[2].charAt(0).toUpperCase() : '') + splitD[1].charAt(0).toUpperCase() + '' + splitD[0].charAt(0).toUpperCase() + '' + (item.participants.length !== (index + 1) ? ', ' : '')}

                                    </Typography>
                                </React.Fragment>
                            )
                        } else {
                            return (
                                <React.Fragment key={`pSubActivity_${index}`}>
                                    <Typography
                                        fontSize={11}
                                        key={vals.userID}
                                        component="span"
                                        title={vals.participant}
                                        sx={{
                                            marginRight: '2px',
                                            cursor: 'pointer',
                                            fontWeight: endUser ? userInfo.userID === vals.userID ? '900' : null : null,
                                        }}>
                                        {vals.participant.replace(',', ' ') + (item.participants.length !== (index + 1) ? ', ' : '')}
                                    </Typography>
                                </React.Fragment>
                            )
                        }
                    })
                }
            },
            {
                key: "isRowPublished",
                name: !props.showUserActivity ? "Action" : "",
                width: props.showUserActivity ? '8%' : '15%',
                // cellClass(row) {
                //     return classes.enablesTextWrapping
                // },
                renderCell({ row }) {
                    const item = row.actualData;
                    return (
                        // <Box sx={{
                        //     display: 'flex', alignItems: 'center', justifyContent: 'center'
                        // }}>
                        <>
                            {item.isRowPublished ? (
                                <IconButton>
                                    <CheckCircleIcon
                                        fontSize="small"
                                        style={{ color: '#008000' }}
                                    />
                                </IconButton>
                            ) : (
                                <IconButton>
                                    <UnpublishedIcon
                                        fontSize="small"
                                        style={{ color: '#FF5733' }}
                                    />
                                </IconButton>
                            )
                            }

                            {!props.showUserActivity ?
                                <>
                                    <Tooltip title="Add Participants" aria-label="add-participants">
                                        <IconButton
                                            color="primary"
                                            onClick={() => {
                                                //saveGridScrollPosition(row);
                                                props.handleAddParticipants(row);

                                            }}
                                        >
                                            <GroupAddIcon
                                                fontSize="small"
                                                color={'primary'}
                                            />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title="View Participants" aria-label="view-participants">
                                        <IconButton
                                            color="primary"
                                            onClick={() => props.handleViewParticipants(row)}
                                        >
                                            <Badge badgeContent={item.participants && item.participants.length > 0 ? item.participants.length : 0} color="primary">
                                                <PeopleAltIcon
                                                    fontSize="small"
                                                    color={'primary'}
                                                />
                                            </Badge>
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Edit" aria-label="edit">
                                        <IconButton
                                            color="primary"
                                            onClick={() => {
                                                props.editRow(row);
                                                // saveGridScrollPosition(row);
                                            }}>
                                            <EditOutlined
                                                fontSize="small"
                                                color={'primary'}
                                            />
                                        </IconButton>
                                    </Tooltip>
                                </>
                                : null}
                        </>
                        // </Box>
                    )
                }
            }
        ];
    // }, [activityData]);

    const ActivityGrid = ({ products, direction, index }) => {
        const gridRef = useRef(null);

        // useEffect(() => {
        //     if (scrollPositionObj && scrollPositionObj.length > 0 && products && products.length > 0) {
        //         let date = moment(products[0]?.actualData.startDateTime).format('MM/DD/YYY');
        //         let scrollData = scrollPositionObj.find(i => i.date === date);
        //         if (scrollData) {
        //             //gridRef?.current?.element.scrollTo(0, scrollData.scrollPosition);
        //             gridRef.current.scrollToCell({ rowIdx: scrollData.scrollPosition });

        //         }
        //     }

        // }, [gridRef])

        // const onScroll = (e) => {
        //     //added below code to persist scroll position on update
        //     let obj = [...scrollPositionObj];
        //     if (!obj.some(i => i.date === date)) {
        //         obj.push({ date: date, scrollPosition: e?.nativeEvent?.target?.scrollTop });
        //     }
        //     else {
        //         let index = obj.findIndex(i => i.date === date);
        //         obj[index].scrollPosition = e?.nativeEvent?.target?.scrollTop;
        //     }
        //     setScrollPositionObj(obj);
        // }

        return (
            <Box className={classes.activityContainer}>
                <DataGrid
                    ref={gridRef}
                    rows={products}
                    columns={activityColumns}
                    rowKeyGetter={rowKeyGetter}
                    style={{ blockSize: 300 }}
                    // rowHeight={50}
                    direction={direction}
                    headerRowHeight={GRID_HEADER_ROW_HEIGHT}
                    rowHeight={GRID_ROW_HEIGHT}//{rowHeight}
                //onScroll={(e) => { onScroll(e) }}
                />
            </Box>
        )
    }

    function rowHeight() {
        // should be based on the content of the row
        return 40 + Math.round(Math.random() * 50);
    }

    return (
        <Box className={classes.container}>
            {rows && rows.length > 0 ?
                <DataGrid
                    rowKeyGetter={rowKeyGetter}
                    columns={columns}
                    rows={rows}
                    onRowsChange={onRowsChange}
                    headerRowHeight={0}
                    rowHeight={row => (row.type === "DETAIL" ? row.rowHeight : 45)}
                    className={'fill-grid'}
                    // enableVirtualization={false}
                    direction={props.direction}
                    onCellKeyDown={(_, event) => {
                        if (event.isDefaultPrevented()) {
                            // skip parent grid keyboard navigation if nested grid handled it
                            event.preventGridDefault()
                        }
                    }}

                />
                : <ListItem className={classes.listItemContent}>
                    <Card
                        classes={{ root: classes.paperContent }}
                        sx={{ width: '100%' }}>
                        <CardContent
                            sx={{ p: 2 }}
                            className={classes.cardContent}>
                            <Box className={classes.rowContent}>
                                No data found
                            </Box>
                        </CardContent>
                    </Card>
                </ListItem>
            }
        </Box>
    )
}

export default CustomScheduleGrid;


function rowKeyGetter(row) {
    const id = row.id != undefined ? row.id : row.actualData.activityID;
    return id;
}